import script from "./InternalSaleForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalSaleForm.vue?vue&type=script&setup=true&lang=ts"

import "./InternalSaleForm.vue?vue&type=style&index=0&id=018c968f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018c968f"]])

export default __exports__